import React from 'react';
import { Breadcrumb } from 'antd/lib';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormCrearExpediente from './FormCrearExpediente';
import insertExpediente from '../../../graphql/mutations/contravenciones/InsertExpediente.graphql';
import { errorService } from '../../../graphql/utils/utils';

@graphql(insertExpediente, {
  name: 'insertExpediente',
})
class CrearExpediente extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
  };

  onSubmit = datos => {
    // console.log('Los datos que me llegan son!');
    // console.log(datos);

    this.props
      .insertExpediente({
        variables: {
          objExpediente: datos,
        },
      })
      .then(respuesta => {
        console.log('La respuesta del servidor fue....');
        console.log(respuesta);

        let expediente = respuesta.data.insertExpediente;

        this.props.history.push(
          `/contravenciones/expedientes/${expediente._id}`
        );
      })
      .catch(err => {
        console.log('Error a la hora de crear un expediente');
        console.log(err);
        errorService(err, {
          objExpediente: datos,
        });
      });
  };

  onCancel = () => {
    this.setState({
      fase: 0,
    });
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Expediente</Breadcrumb.Item>
          <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
        </Breadcrumb>
        <FormCrearExpediente onSubmit={this.onSubmit} />
      </div>
    );
  }
}

export default withApollo(CrearExpediente);
